import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import {
  PremiumPaymentResponse,
  PremiumPaymentSchedule,
  isPaidPremiumToHumanReadable,
  isPaidPremiumToHumanReadableForClient,
} from 'ah-api-gateways';
import { formatDate, SIMPLE_DATE_WITH_FULL_MONTH_FORMAT } from 'ah-common-lib/src/helpers/time';
import { useManagedListing, defineUseManagedListingProps, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { optionPremiumPaymentSettlementFullTableFields } from 'ah-trades/src/models/optionPremiumPaymentSettlementTableFields';
import { useAhTradesState } from 'ah-trades';
import { of } from 'rxjs';

interface PremiumPaymentScheduleEmit extends UseManagedListingEmits<PremiumPaymentResponse | PremiumPaymentSchedule> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionPremiumSchedulePaymentsListing',
  props: {
  tradeId: {
    type: String,
  },
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: optionPremiumPaymentSettlementFullTableFields }),
  },
  data: {
    type: Array as PropType<PremiumPaymentSchedule[]>,
  },
  ...defineUseManagedListingProps<PremiumPaymentResponse | PremiumPaymentSchedule>(),
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;

const formatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 });



const tradeState = useAhTradesState();



const isAHUser = computed(() => tradeState.store.useAuthStore().isAHUser);

function isPaidPremiumToHuman(isPaid: boolean) {
  return isAHUser.value ? isPaidPremiumToHumanReadable(isPaid) : isPaidPremiumToHumanReadableForClient(isPaid);
}

const managedListing = useManagedListing<PremiumPaymentResponse | PremiumPaymentSchedule>({
  loadDataRequest(query) {
    if (props.data) {
      return of({
        pageNumber: 0,
        pageSize: props.data.length,
        total: props.data.length,
        list: props.data,
      });
    } else {
      return tradeState.services.premiumService.listPremiumPayments({ ...query, tradeId: props.tradeId });
    }
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

return { __sfc: true,formatter, props, tradeState, emit, isAHUser, isPaidPremiumToHuman, managedListing, formatDate, SIMPLE_DATE_WITH_FULL_MONTH_FORMAT, formatCurrencyValue }
}

})